export default __webpack_public_path__ + "static/media/fromarchive.f17f3ca2.svg";